import React from 'react';
import { Row, Col } from 'react-bootstrap';
import dayjs from 'dayjs';

const SummarySection = ({systems, pages, date}) => {
    const {createdAt_gte, createdAt_lt} = date;
    const diffDays = dayjs(createdAt_lt).diff(dayjs(createdAt_gte), "days") + 1;

    const items = [
        { label: 'ລະບົບ', amount: systems?.amount || 0, detail: systems?.listName || '—' },
        { label: 'ເພສ', amount: pages?.amount || 0, detail: pages?.listName || '—' },
        { label: 'ຊ່ວງວັນທີ', amount: diffDays > 0 ? `${diffDays} ວັນ` : '—', detail: (createdAt_gte && createdAt_lt) ? `${createdAt_gte} - ${createdAt_lt}` : '—' },
    ];

    return (
        <Row className="g-3">
            {items.map((item, index) => (
                <Col key={index} xs={12} md={4}>
                    <div className="d-flex flex-column">
                        <span className="text-muted small">{item.label}</span>
                        <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>{item.amount}</span>
                        <span className="text-muted small text-truncate" title={item.detail}>{item.detail}</span>
                    </div>
                </Col>
            ))}
        </Row>
    );
}

export default SummarySection